"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNeutralPaymentStepSegment = exports.shouldPrioritizeBankPayment = void 0;
const common_1 = require("../enums/common");
const payment_1 = require("../enums/payment");
const payment_methods_1 = require("../internationalization/features/payment-methods");
const ONE_TIME_BANK_PRIORITY_MIN = 1_000_00;
const MONTHLY_DONATION_BANK_PRIORITY_MIN = 200_00;
const NEUTRAL_PAYMENT_STEP_MAX = 5_000_00;
const shouldPrioritizeBankPayment = ({ amount, formType, organizationCountry, stripeRecurrenceInterval, }) => {
    if (amount >= ONE_TIME_BANK_PRIORITY_MIN) {
        return true;
    }
    return (formType === common_1.FormType.DonationForm &&
        stripeRecurrenceInterval === payment_1.StripeRecurringInterval.month &&
        (0, payment_methods_1.countryHasAch)(organizationCountry) &&
        amount >= MONTHLY_DONATION_BANK_PRIORITY_MIN);
};
exports.shouldPrioritizeBankPayment = shouldPrioritizeBankPayment;
const isNeutralPaymentStepSegment = ({ amount, organizationCountry, stripeRecurrenceInterval, }) => stripeRecurrenceInterval === null &&
    (0, payment_methods_1.countryHasAch)(organizationCountry) &&
    amount >= ONE_TIME_BANK_PRIORITY_MIN &&
    amount < NEUTRAL_PAYMENT_STEP_MAX;
exports.isNeutralPaymentStepSegment = isNeutralPaymentStepSegment;
